import {
  fetchDoLogin,
  fetchGetCaptcha,
  fetchDoLogout,
  fetchValidateTokenBSS,
  fetchMenuList,
  fetchValidateTokenBRISPOT,
  fetchHeadline,
  fetchListServices,
  fetchListProduk,
  fetchCallToAction,
  fetchListWordStyling,
  fetchDoLoginSingleProduct,
} from "@/src/services/login";
import { fetchTermCondition } from "@/src/utils/functions/fetcherTermConditions";
import { identifyUser, clearUser } from "@/src/lib/monitoring";
import {
  CAPTCHA,
  LOADING_CAPTCHA,
  LOGIN,
  LOADING_LOGIN,
  LOGOUT,
  LOADING_LOGOUT,
  VALIDATE_TOKEN_BSS,
  LOADING_VALIDATE_TOKEN_BSS,
  TERM_AND_CONDITION,
  LOADING_TERM_AND_CONDITION,
  LOADING_MENU_LIST,
  MENU_LIST,
  LOADING_VALIDATE_TOKEN_BRISPOT,
  VALIDATE_TOKEN_BRISPOT,
  HEADLINE,
  LIST_LAYANAN,
  LIST_PRODUK,
  CALL_TO_ACTION,
  LOADING_HEADLINE,
  LOADING_LIST_LAYANAN,
  LOADING_LIST_PRODUK,
  LOADING_CALL_TO_ACTION,
  LIST_WORD_STYLING,
  LOADING_LIST_WORD_STYLING,
} from "@/src/redux/constants/login";
import Cookies from "universal-cookie";

export function getCaptcha(payload: any): (dispatch: any) => void {
  return (dispatch) => {
    dispatch(loadingCaptcha());

    fetchGetCaptcha(payload)
      .then((res: any) => {
        dispatch(captchaContentFetched(res));
        return res;
      })
      .catch((err: any) => {
        dispatch(captchaContentFetched(err));
      });
  };
}

export function loginAction(payload: any): (dispatch: any) => void {
  // console.log("payload login", payload);
  return (dispatch) => {
    dispatch(loadingLogin());
    fetchDoLogin(payload)
      .then((res_login: any) => {
        if (res_login?.status_code !== 200) {
          dispatch(loginDatasFetched(res_login));
          return res_login;
        }

        // dispatch(loginDatasFetched(res_login));

        // console.log("res_login", res_login);
        fetchMenuList(res_login.data.token)
          .then((res_menu: any) => {

            const combinedResult = {
              ...res_login,
              data: {
                ...res_login.data,
                user: {
                  ...res_login.data.user,
                  access: res_menu.data.data
                }
              }
            };

            dispatch(loginDatasFetched(combinedResult));

            identifyUser({
              id: combinedResult.data.user.pernr,
              username: combinedResult.data.user.sname,
            });

            // console.log("combinedResult", combinedResult);
            const filteredMobile = res_menu.data.data?.filter((item: any) =>
              item?.device?.some((dv: any) => dv?.device === "mobile")
            );


            if (res_menu.data.data.length < 1 && res_menu.data.data[0].ProductName !== 'link5') {
              fetchDoLoginSingleProduct(res_menu.data.user.access[0].product_id, res_login?.data?.token)
                .then((res: any) => {
                  const cookie = new Cookies()

                  cookie.remove("user", { path: '/' });
                  cookie.remove("userData", { path: '/' });



                  cookie.set("user", res?.data?.token, {
                    path: "/",
                    expires: new Date(res?.data?.expire),
                  });
                  cookie.set("userData", res?.data?.user, {
                    path: "/",
                    expires: new Date(res?.data?.expire),
                  });

                  localStorage.setItem("data", JSON.stringify(res?.data?.user));
                  localStorage.setItem("accesses", JSON.stringify(res?.data?.user));
                  dispatch(loginDatasFetched(combinedResult));
                  const mobileUrl = filteredMobile?.find((el: any) => el?.device === "mobile")

                  window.location.assign(`${mobileUrl.main_url}${mobileUrl?.uri}`);
                })
            }


            dispatch(loginDatasFetched(combinedResult));
            dispatch(menuListFetched(res_menu));
            return combinedResult;
          })
          .catch(() => {
            dispatch(menuListFetched([]));
          });

      })
      .catch((err: any) => {
        console.log("error login", err);
        dispatch(loginDatasFetched(err));
      });
  };
}

export function clearLoginData(): (dispatch: any) => void {
  return (dispatch) => {
    clearUser();
    dispatch(loginDatasFetched([]));
  };
}

export function logoutAction(
  payload: any,
  token: string
): (dispatch: any) => void {
  return (dispatch) => {
    dispatch(loadingLogout());
    fetchDoLogout(payload, token)
      .then((res: any) => {
        clearUser();
        dispatch(loginDatasFetched([]));
        dispatch(logoutDatasFetched(res));
        return res;
      })
      .catch((err: any) => {
        dispatch(loginDatasFetched(err));
      });
  };
}

export function validateTokenBSS(payload: any): (dispatch: any) => void {
  return (dispatch) => {
    dispatch(loadingValidateTokenBSS());

    fetchValidateTokenBSS(payload)
      .then((res: any) => {
        dispatch(validateTokenBSSFetched(res));
        return res;
      })
      .catch(() => {
        dispatch(validateTokenBSSFetched([]));
      });
  };
}

export function validateTokenBRISPOT(payload: any): (dispatch: any) => void {
  return (dispatch) => {
    dispatch(loadingValidateTokenBRISPOT());
    fetchValidateTokenBRISPOT(payload)
      .then((res: any) => {
        dispatch(validateTokenBRISPOTFetched(res));
        return res;
      })
      .catch(() => {
        dispatch(validateTokenBRISPOTFetched([]));
      });
  };
}

export function termConditionsFetch(): (dispatch: any) => void {
  return (dispatch) => {
    dispatch(loadingTermAndCondition());

    fetchTermCondition()
      .then((res: any) => {
        dispatch(termAndConditionFetched(res));
        return res;
      })
      .catch(() => {
        dispatch(termAndConditionFetched([]));
      });
  };
}

export function menuListAction(
  token: string
): (dispatch: any) => void {
  return (dispatch) => {
    dispatch(loadingMenuList());
    fetchMenuList(token)
      .then((res: any) => {
        dispatch(menuListFetched(res));
        return res;
      })
      .catch(() => {
        dispatch(menuListFetched([]));
      });
  };
}

export function listWordStylingAction(): (dispatch: any) => void {
  return (dispatch) => {
    dispatch(loadingWListWordStyling());

    fetchListWordStyling()
      .then((res: any) => {
        dispatch(listWordStylingFetched(res));
        return res;
      })
      .catch((err: any) => {
        dispatch(listWordStylingFetched(err));
      });
  };
}

export function headlineAction(): (dispatch: any) => void {
  return (dispatch) => {
    dispatch(loadingHeadline());

    fetchHeadline()
      .then((res: any) => {
        dispatch(headlineFetched(res));
        return res;
      })
      .catch((err: any) => {
        dispatch(headlineFetched(err));
      });
  };
}

export function listLayananAction(): (dispatch: any) => void {
  return (dispatch) => {
    dispatch(loadingListLayanan());

    fetchListServices()
      .then((res: any) => {
        dispatch(listLayananFetched(res));
        return res;
      })
      .catch((err: any) => {
        dispatch(listLayananFetched(err));
      });
  };
}

export function listProdukAction(): (dispatch: any) => void {
  return (dispatch) => {
    dispatch(loadingListProduk());

    fetchListProduk()
      .then((res: any) => {
        dispatch(listProdukFetched(res));
        return res;
      })
      .catch((err: any) => {
        dispatch(listProdukFetched(err));
      });
  };
}

export function callToActionAction(): (dispatch: any) => void {
  return (dispatch) => {
    dispatch(loadingCallToAction());

    fetchCallToAction()
      .then((res: any) => {
        dispatch(callToActionFetched(res));
        return res;
      })
      .catch((err: any) => {
        dispatch(callToActionFetched(err));
      });
  };
}

function captchaContentFetched(captchaContent: any) {
  return {
    type: CAPTCHA,
    captchaContent,
  };
}

function loginDatasFetched(loginDatas: any) {
  return {
    type: LOGIN,
    loginDatas,
  };
}

function logoutDatasFetched(logoutDatas: any) {
  return {
    type: LOGOUT,
    logoutDatas,
  };
}

function validateTokenBSSFetched(validateBSSDatas: any) {
  return {
    type: VALIDATE_TOKEN_BSS,
    validateBSSDatas,
  };
}

function validateTokenBRISPOTFetched(validateBRISPOTDatas: any) {
  return {
    type: VALIDATE_TOKEN_BRISPOT,
    validateBRISPOTDatas,
  };
}

function termAndConditionFetched(termCondition: any) {
  return {
    type: TERM_AND_CONDITION,
    termCondition,
  };
}

function menuListFetched(menuListData: any) {
  return {
    type: MENU_LIST,
    menuListData,
  };
}

function listWordStylingFetched(listWordStyling: any) {
  return {
    type: LIST_WORD_STYLING,
    listWordStyling,
  };
}
function headlineFetched(headline: any) {
  return {
    type: HEADLINE,
    headline,
  };
}
function listLayananFetched(listLayanan: any) {
  return {
    type: LIST_LAYANAN,
    listLayanan,
  };
}
function listProdukFetched(listProduk: any) {
  return {
    type: LIST_PRODUK,
    listProduk,
  };
}
function callToActionFetched(callToAction: any) {
  return {
    type: CALL_TO_ACTION,
    callToAction,
  };
}

function loadingCaptcha() {
  return { type: LOADING_CAPTCHA };
}

function loadingLogin() {
  return { type: LOADING_LOGIN };
}

function loadingLogout() {
  return { type: LOADING_LOGOUT };
}

function loadingValidateTokenBSS() {
  return { type: LOADING_VALIDATE_TOKEN_BSS };
}

function loadingValidateTokenBRISPOT() {
  return { type: LOADING_VALIDATE_TOKEN_BRISPOT };
}

function loadingTermAndCondition() {
  return { type: LOADING_TERM_AND_CONDITION };
}

function loadingMenuList() {
  return { type: LOADING_MENU_LIST };
}

function loadingWListWordStyling() {
  return { type: LOADING_LIST_WORD_STYLING };
}

function loadingHeadline() {
  return { type: LOADING_HEADLINE };
}

function loadingListLayanan() {
  return { type: LOADING_LIST_LAYANAN };
}

function loadingListProduk() {
  return { type: LOADING_LIST_PRODUK };
}

function loadingCallToAction() {
  return { type: LOADING_CALL_TO_ACTION };
}
